// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"6cbc0283","150":"73076813","318":"fa682a20","323":"26f67c32","337":"958a8d56","453":"0ad0783f","593":"70ec9c4e","877":"cb75b3c3","954":"d137a15a"}[chunkId] + ".chunk.js";
};